import React from 'react';
import { formatAmount, formatINR } from 'utils';

interface LeftPanelProps {
  selectedAddress: any;
  wallet: any;
  useWallet: boolean;
  isWalletSufficient: boolean;
  paymentMethod: string;
  handleWalletChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePaymentMethodChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAccordionOpen: boolean;
  setIsAccordionOpen: (val: boolean) => void;
  selectedProduct: any;
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  selectedAddress,
  wallet,
  useWallet,
  isWalletSufficient,
  paymentMethod,
  handleWalletChange,
  handlePaymentMethodChange,
  isAccordionOpen,
  setIsAccordionOpen,
  selectedProduct,
}) => {


  return (
    <div className='summary-left'>
      {/* Delivering Address */}
      <div className='delivering-address'>
        <h6>
          Deliver to: {selectedAddress.firstName} {selectedAddress.lastName}
          <span className='badge'>{selectedAddress.addressType}</span>
        </h6>
        <p>
          <strong>Address: </strong>
          {selectedAddress.street1 && `${selectedAddress.street1}, `}
          {selectedAddress.street2 && `${selectedAddress.street2}, `}
          {selectedAddress.landmark && `${selectedAddress.landmark}, `}
          {selectedAddress.city && `${selectedAddress.city}, `}
          {selectedAddress.state && `${selectedAddress.state}, `}
          {selectedAddress.country && `${selectedAddress.country}`}
          {selectedAddress.pinCode && ` - ${selectedAddress.pinCode}`}
        </p>
        <p>
          <strong>Contact: </strong>
          {selectedAddress.contactNumber}
        </p>
      </div>

      {/* Order Summary Accordion */}
      <div className='order-summary'>
        <div
          className='accordion-header'
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        >
          <h6>Order Summary</h6>
          <svg
            className={`accordion-icon ${isAccordionOpen ? 'open' : ''}`}
            width='12'
            height='12'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M6 9l6 6 6-6'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>

        {isAccordionOpen && (
          <div className='accordion-content'>
            <div className='order-items-container'>
              <div className='order-item'>
                <img
                  src={selectedProduct?.thumbnail[0]}
                  alt='Product'
                  className='product-thumbnail'
                />
                <div className='product-info'>
                  <div className='info-block'>
                    <p className='info-heading'>Name</p>
                    <p className='info-value'>{selectedProduct.productName}</p>
                  </div>
                  <div className='info-block'>
                    <p className='info-heading'>Purity</p>
                    <p className='info-value'>{selectedProduct.purity}%</p>
                  </div>
                  <div className='info-block'>
                    <p className='info-heading'>Weight</p>
                    <p className='info-value'>{selectedProduct.weight} g</p>
                  </div>
                  <div className='info-block'>
                    <p className='info-heading'>Quantity</p>
                    <p className='info-value'>1 Unit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Wallet & Payment Method */}
      {/* <div className='choose-payment'>
        <h6>
          Available Wallet Balance{' '}
          <span className='wallet-balance'>
            ({`${formatINR(wallet)}` || '0.00'})
          </span>
        </h6>
        <label>
          <input
            type='checkbox'
            checked={useWallet}
            onChange={handleWalletChange}
            disabled={wallet === 0}
          />{' '}
          Use Wallet
        </label>

        <div className='payment-method-spacing'></div>

        <h6>Payment Method</h6>
        <label>
          <input
            type='radio'
            name='payment'
            value='UPI'
            onChange={handlePaymentMethodChange}
            disabled={useWallet && isWalletSufficient}
          />{' '}
          UPI
        </label>
        <label>
          <input
            type='radio'
            name='payment'
            value='NEBK'
            onChange={handlePaymentMethodChange}
            disabled={useWallet && isWalletSufficient}
          />{' '}
          Net Banking
        </label>
      </div> */}

      <div className='choose-payment'>
        <h6>
          Available Wallet Balance{' '}
          <span className='wallet-balance'>
            ({`${formatINR(wallet)}` || '0.00'})
          </span>
        </h6>

        <label>
          <input
            type='checkbox'
            checked={useWallet}
            onChange={handleWalletChange}
            disabled={wallet === 0}
          />{' '}
          Use Wallet
        </label>

        <div className='payment-method-spacing'></div>

        <h6>Payment Method</h6>

        <label>
          <input
            type='radio'
            name='payment'
            value='UPI'
            checked={paymentMethod === 'UPI'}
            onChange={handlePaymentMethodChange}
            disabled={useWallet && isWalletSufficient}
          />{' '}
          UPI
        </label>

        <label>
          <input
            type='radio'
            name='payment'
            value='NEBK'
            checked={paymentMethod === 'NEBK'}
            onChange={handlePaymentMethodChange}
            disabled={useWallet && isWalletSufficient}
          />{' '}
          Net Banking
        </label>
      </div>

    </div>
  );
};

export default LeftPanel;
